import { forwardRef, ReactNode, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface TuiPromptProps extends HTMLAttributes<HTMLDivElement> {
  user?: string;
  host?: string;
  path?: string;
  children: ReactNode;
  caret?: boolean;
  className?: string;
}

/** Single command-line row: `user@host:path# command` */
export const TuiPrompt = forwardRef<HTMLDivElement, TuiPromptProps>(
  ({ user = "root", host = "frisyre", path = "~", children, caret = false, className, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex flex-wrap items-baseline gap-x-2 text-sm font-mono", className)}
        {...rest}
      >
        <span className="text-muted-foreground shrink-0">
          <span className="text-foreground/70">{user}</span>
          <span className="text-muted-foreground">@</span>
          <span className="text-foreground/70">{host}</span>
          <span className="text-muted-foreground">:{path}</span>
          <span className="text-primary">#</span>
        </span>
        <span className={cn("text-foreground", caret && "tui-caret")}>{children}</span>
      </div>
    );
  },
);
TuiPrompt.displayName = "TuiPrompt";
